import {
  FF_APP_INVOICE_NEW_DESIGN,
  FF_EINVOICE_XML_EXPORT_UI,
  FF_HELP_CENTER,
  FF_INVOICE_SUBSCRIPTION_DOWNGRADE_FLOW,
  FF_NEW_ONBOARDING,
  FF_SHOPIFY_FLOW,
  FF_SHOW_ORDER_TEMPLATE,
  FF_THEME_EDIT_CODE,
} from '@constant/featureFlags'

import { useFeatureFlag, useLegacyFeatureFlag } from '@fordeer/feature-flags'

export const useAppInvoiceNewDesignFeatureFlag = () =>
  useLegacyFeatureFlag(FF_APP_INVOICE_NEW_DESIGN)
export const useEInvoiceXmlExportUiFeatureFlag = () =>
  useFeatureFlag(FF_EINVOICE_XML_EXPORT_UI)
export const useHelpCenterFeatureFlag = () => useFeatureFlag(FF_HELP_CENTER)
export const useShopifyFlowFeatureFlag = () => useFeatureFlag(FF_SHOPIFY_FLOW)

export const useDowngradeFlowFeatureFlag = () =>
  useFeatureFlag(FF_INVOICE_SUBSCRIPTION_DOWNGRADE_FLOW)

export const useNewOnboardingFeatureFlag = () =>
  useFeatureFlag(FF_NEW_ONBOARDING)

export const useThemeEditCodeFeatureFlag = () =>
  useFeatureFlag(FF_THEME_EDIT_CODE)

export const useShowOrderTemplateFeatureFlag = () =>
  useFeatureFlag(FF_SHOW_ORDER_TEMPLATE)
